<template>
  <div>
    <el-row>
        <el-form size="small">
          <el-col :span="6">
          <el-form-item>
            <el-input placeholder="请输入资源名称"  v-model="resourceName" maxlength="45" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
      </el-col>
            <el-button type="primary" size="small" style="margin-left:15px" @click="handleSearch">查询</el-button>
        </el-form>
    </el-row>
     <div v-if="!cardLoading && table.total === 0" class="lastest-nothing">
     <span> 暂无数据</span>
    </div>
    <CardList
      class="img-list"
      :data="table.data"
      v-loading="cardLoading"
      v-else
    >
      <div class="img-item" slot="row" slot-scope="{ row: item }">
        <div class="img-item-box">
          <img
            referrerpolicy="no-referrer"
            :key="item.resourceUrl"
            :src="item.resourceUrl"
          />
        </div>
        <div class="img-title">{{ item.resourceName }}</div>
        <div class="img-detail">
          <el-button
          :disabled="item.checked"
            @click="handleRowSelectionChange(item)"
            >选择</el-button
          >
          <el-button @click="handleDelete(item)">删除</el-button>
        </div>
      </div>
    </CardList>

     <el-pagination
          :current-page.sync="currentPage"
          :page-size="10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
           :total="table.total"
        ></el-pagination>
  </div>
</template>
<script>
import { CardList } from '@ccprivate/admin-toolkit'
import { mapState } from 'vuex'
export default {
  components: {
    CardList
  },
  props: {
    spaceInfo: {
      type: Object
    },
    type: {
      type: Number
    }
  },
  data() {
    return {
      cardLoading: false,
      currentPage: 1,
      pageSize: 10,
      table: {
        data: [],
        total: 0
      },
      resourceName: undefined
    }
  },
  computed: {
    ...mapState({
      selectedPictureResource: state => state.selectedPictureResource,
      pictureTrackList: state => state.pictureTrackList,
      backImageTrackList: state => state.backImageTrackList,
      selectedBackImageResource: state => state.selectedBackImageResource
    })
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      if (this.isfilter) {
        this.fetch({ resourceName: this.resourceName })
      } else {
        this.fetch()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.isfilter) {
        this.fetch({ resourceName: this.resourceName })
      } else {
        this.fetch()
      }
    },
    fetch(filter) {
      this.cardLoading = true
      const params = { ...filter, ...{ resourceType: this.type, spaceId: this.spaceInfo.spaceId }, ...{ pageSize: this.pageSize, pageNo: this.currentPage } }
      this.$service.getHistoryResource(params).then(res => {
        this.cardLoading = false
        this.table.total = res.total || 0
        this.table.data = (res.rows || []).map(item => {
          return {
            agentAccountId: item.agentAccountId,
            createTime: item.createTime,
            duration: item.duration || 1,
            format: item.format,
            height: item.height,
            md5: item.md5,
            relativePath: item.relativePath,
            resourceIcon: item.resourceIcon,
            resourceId: item.resourceId,
            resourceName: item.resourceName,
            resourceType: item.resourceType,
            // resourceUrl: 'http://beta-res.hoisin.coocaatv.com/img/20210317/20210317170317468908.jpg',
            resourceUrl: item.resourceUrl,
            size: item.size,
            spaceId: item.spaceId,
            width: item.width,
            checked: this.type === 2 ? this.selectedPictureResource.some((e) => e.md5 === item.md5) : false
          }
        })
      }).catch(() => {
        this.cardLoading = false
      })
    },
    handleRowSelectionChange(row) {
      row.checked = true
      this.$emit('select-card', row)
      this.isfilter = false
    },
    handleDelete(e) {
      if (this.type === 0) {
        if (this.backImageTrackList[0].length > 0 && this.backImageTrackList[0][0].md5 === e.md5) {
          this.$message('背景图在轨道上，不允许删除')
          return
        }
      } else {
        const pictureTrackList = this.pictureTrackList.filter(item => item.length > 0)
        const res = pictureTrackList.some(item => {
          return item.some(el => el.md5 === e.md5)
        })
        if (res) {
          this.$message('贴图在轨道上，不允许删除')
          return
        }
      }
      this.$confirm('确认是否删除', '提示', {
        center: true,
        showClose: false
      }).then(() => {
        this.$service.deleteResource([e.resourceId]).then(res => {
          if (this.type === 0) {
            if (this.selectedBackImageResource.some(item => item.md5 === e.md5)) {
              this.$store.commit('deletBackIamgeResource', 0)
            }
          } else {
            const index = this.selectedPictureResource.findIndex(item => item.md5 === e.md5)
            if (index > -1) {
              this.$store.commit('deletPictureResource', { index: index, num: 1 })
            }
          }
          this.fetch()
        })
      })
    },
    handleSearch() {
      this.isfilter = false
      this.fetch({ resourceName: this.resourceName })
    }

  },
  created() {
    this.fetch()
  }
}
</script>
<style lang="stylus" scoped>
.img-list-none
  width 100%
  display flex
  flex-direction row
  justify-content center
  align-items center
  color #909399
.img-list
  width 100%
  display flex
  flex-direction row
  height 392px
.img-list
  >>>.el-row
    width 100%
    margin 0 !important
>>>.card-item-wrapper
  width 19.1%
  margin-right 9px
  margin-bottom 9px
  padding 0px !important
  // margin-right 9px
  height 175px
  background rgba(255,255,255,1)
  border-radius 2px
  border 1px solid rgba(233,233,233,1)
.img-list>>>.card-item-wrapper:nth-child(5n+5)
  margin-right 0
.img-item
  .img-item-box
    height 116px
    img
      width 100%
      max-height 100%
  .img-detail
    position absolute
    top 0
    text-align center
    background rgba(8, 8, 8, 0.5)
    width 100%
    display none
    height inherit
    line-height 175px
    .detail-button
      margin-top -50px
      top 50%
      position relative
    span
      display block
  &:hover
    .img-detail
      display block
  .img-info
    font-size 12px
    padding 0px 8px 8px
  .img-title
    height 40px
    line-height 20px
    padding 8px 8px 0px 8px
    position relative
    text-overflow ellipsis
    overflow hidden
    display: -moz-box
    -moz-line-clamp 2 !important
    -moz-box-orient vertical
    /* autoprefixer: off */
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  .img-status
    float right
  .img-preview
    position absolute
    top 0
    right 0
    cursor pointer
    height 20px
    color #444
    background #fff
    padding 0px 5px
.lastest-nothing
  margin 10px 0px 50px
  height 40px
  text-align center
  color #999
</style>
